import _objectSpread from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { asyncRoutes, constantRoutes } from '@/router';
// import store from '@/store'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(role, route) {
  if (route.meta && route.meta.roles) {
    return route.meta.roles.includes(role);
  } else {
    return true;
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, role) {
  var res = [];
  routes.forEach(function (route) {
    var tmp = _objectSpread({}, route);
    if (hasPermission(role, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, role);
      }
      res.push(tmp);
    }
  });
  return res;
}
var getters = {
  addRoutes: function addRoutes(state) {
    return state.addRoutes;
  }
};
var state = {
  routes: [],
  addRoutes: []
};
var profile = [];
var clearance = [];
var staff = [];
var VIPcenter = [];
var clearanceException = [];
var mutations = {
  SET_ROUTES: function SET_ROUTES(state, routes) {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
  CHANGE_ROUTES_ICON: function CHANGE_ROUTES_ICON(state, data) {
    state.routes.forEach(function (route) {
      if (route.meta) {
        if (route.meta.title === '报关单证' && clearance.length === 0) {
          clearance.push(route.meta.icon);
        }
        if (route.meta.title === '客户档案' && profile.length === 0) {
          profile.push(route.meta.icon);
        }
        if (route.meta.title === '平台管理' && staff.length === 0) {
          staff.push(route.meta.icon);
        }
        if (route.meta.title === '个人中心' && VIPcenter.length === 0) {
          VIPcenter.push(route.meta.icon);
        }
        if (route.meta.title === '清关异常' && clearanceException.length === 0) {
          clearanceException.push(route.meta.icon);
        }
        if (route.meta.title !== data.title) {
          if (route.meta.title === '报关单证') {
            route.meta.icon = "".concat(clearance[0], "false");
          }
          if (route.meta.title === '清关异常') {
            route.meta.icon = "".concat(clearanceException[0]);
          }
          if (route.meta.title === '客户档案') {
            route.meta.icon = "".concat(profile[0]);
          }
          if (route.meta.title === '平台管理') {
            route.meta.icon = "".concat(staff[0]);
          }
          if (route.meta.title === '个人中心') {
            route.meta.icon = "".concat(VIPcenter[0]);
          }
        } else {
          route.meta.icon = data.icon;
        }
      }
    });
  }
};
var actions = {
  generateRoutes: function generateRoutes(_ref, role) {
    var commit = _ref.commit;
    return new Promise(function (resolve) {
      var accessedRoutes = filterAsyncRoutes(asyncRoutes, role);
      commit('SET_ROUTES', accessedRoutes);
      resolve(accessedRoutes);
    });
  }
};
export default {
  namespaced: true,
  getters: getters,
  state: state,
  mutations: mutations,
  actions: actions
};